import { HotjarTheme, hotjarTheme } from '@utils/theme';

export const HEADING_NAMES = <const>[
  'header1',
  'header2',
  'header3',
  'header4',
  'header5',
];
export const TEXT_NAMES = <const>[
  'subtitle1',
  'subtitle2',
  'subtitle3',
  'body1',
  'body2',
  'link',
  'caption',
];

export const NAMES = [...HEADING_NAMES, ...TEXT_NAMES];

const DEFAULT_HEADING_SIZES = [52, 42, 32, 28, 20];
const NEXT_HEADING_SIZES = [48, 40, 32, 24, 20];

const SIZES = [
  ...(hotjarTheme === HotjarTheme.DEFAULT
    ? DEFAULT_HEADING_SIZES
    : NEXT_HEADING_SIZES),
  16,
  14,
  12,
  16,
  14,
  14,
  12,
];

const DEFAULT_HEADING_LINE_HEIGHT = [56, 48, 36, 32, 24];
const NEXT_HEADING_LINE_HEIGHT = [56, 48, 40, 28, 24];

export const LINE_HEIGHT = [
  ...(hotjarTheme === HotjarTheme.DEFAULT
    ? DEFAULT_HEADING_LINE_HEIGHT
    : NEXT_HEADING_LINE_HEIGHT),
  24,
  20,
  16,
  24,
  20,
  20,
  16,
];

const DEFAULT_WEIGHT = [
  300, 300, 400, 400, 600, 600, 600, 600, 400, 400, 600, 400,
];
const NEXT_WEIGHT = [
  600, 600, 600, 600, 600, 500, 500, 500, 400, 400, 400, 400,
];

const WEIGHT =
  hotjarTheme === HotjarTheme.DEFAULT ? DEFAULT_WEIGHT : NEXT_WEIGHT;

const OPEN_SANS_FAMILY = `'Open Sans'`;
const ROBOTO_FAMILY = 'Roboto';
const AMBIT_FAMILY = 'Ambit';
export const FONT_FAMILY =
  hotjarTheme === HotjarTheme.DEFAULT ? OPEN_SANS_FAMILY : ROBOTO_FAMILY;
export const HEADING_FONT_FAMILY =
  hotjarTheme === HotjarTheme.DEFAULT ? OPEN_SANS_FAMILY : AMBIT_FAMILY;

const FONT = [
  HEADING_FONT_FAMILY,
  HEADING_FONT_FAMILY,
  HEADING_FONT_FAMILY,
  HEADING_FONT_FAMILY,
  HEADING_FONT_FAMILY,
  FONT_FAMILY,
  FONT_FAMILY,
  FONT_FAMILY,
  FONT_FAMILY,
  FONT_FAMILY,
  FONT_FAMILY,
  FONT_FAMILY,
];

export type TypeName =
  | (typeof HEADING_NAMES)[number]
  | (typeof TEXT_NAMES)[number];

/**
 * **WARNING!** _We're exporting this function in case Insights
 * might need to mimic DS styles on non standard components._
 * Do not use it, unless it's absolutely unnecessary.
 *
 * @Summary Typography styles as a raw object with numeric properties
 */
export function getTextStyleProperties(name: TypeName): {
  fontFamily: string;
  fontSize: number;
  fontWeight: number;
  lineHeight: number;
} {
  const index = NAMES.indexOf(name);

  return {
    fontFamily: FONT[index],
    fontSize: SIZES[index],
    fontWeight: WEIGHT[index],
    lineHeight: LINE_HEIGHT[index],
  };
}

/**
 * returns all needed css attributes for the specified typography. `body2` is the default.
 *
 * example: `text('header2')` returns
 * `
    font-size: 42px;
    font-weight: 300;
    line-height: 48px;
  `
 * @param name - typography name
 */
export const text = (name: TypeName = 'body2'): string => {
  const { fontFamily, fontSize, fontWeight, lineHeight } =
    getTextStyleProperties(name);
  return `
    font-family: ${fontFamily}, Arial, sans-serif;
    font-size: ${fontSize}px;
    font-weight: ${fontWeight};
    line-height: ${lineHeight}px;

  `;
};

const OPEN_SANS_URL =
  'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&display=swap';
const ROBOTO_URL =
  'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap';

export const FONT_URL =
  hotjarTheme === HotjarTheme.DEFAULT ? OPEN_SANS_URL : ROBOTO_URL;
